export const ADD_TO_CART = 'ADD_TO_CART'
export const SET_CART = 'SET_CART'
export const RESET_CART = 'RESET_CART'

export const GET_ADDRESSES_START = 'GET_ADDRESSES_START'
export const GET_ADDRESSES_SUCCESS = 'GET_ADDRESSES_SUCCESS'
export const GET_ADDRESSES_FAIL = 'GET_ADDRESSES_FAIL'

export const SUBMIT_ORDER_START = 'SUBMIT_ORDER_START'
export const SUBMIT_ORDER_SUCCESS = 'SUBMIT_ORDER_SUCCESS'
export const SUBMIT_ORDER_FAIL = 'SUBMIT_ORDER_FAIL'
